export const checkinmanual = {
    text1: "Check-in manual",
    text2: "Insira os dados necessários para o registro do hóspede.",
    text3: "Informações da acomodação",
    text4: "Selecione a acomodação *",
    text5: "Informações pessoais",
    text6: "Nome do hóspede *",
    text7: "Sobrenome do hóspede *",
    text8: "Masculino",
    text9: "Feminino",
    text10: "Prefiro não informar",
    text11: "Outro",
    text12: "Selecione o gênero *",
    text13: "Data de nascimento *",
    text14: "Número de telefone *",
    text15: "Informações da hospedagem",
    text16: "As informações da hospedagem são obrigatórias para prosseguir com o check-in. Preencha todos os campos.",
    text17: "De - Até",
    text18: "Até que data o hóspede ficará hospedado?",
    text19: "E-mail do hóspede *",
    text20: "Selecione o tipo de documento.",
    text21: "Documento de identidade",
    text22: "Passaporte",
    text23: "Tipo de documento",
    text24: "Número do documento",
    text25: "Insira o número do documento",
    text26: "Validade do documento",
    text27: "Validade do documento",
    text28: "Continuar",
    text29: "Check-in manual",
    text30: "Insira os dados necessários para o registro do hóspede.",
    text31: "Assinatura do check-in",
    text32: "Assine na caixa cinza que aparece na tela",
    text33: "Salvar check-in",
    text34: "Processo de check-in concluído com sucesso.",
    text35: "Você precisa selecionar uma acomodação para atribuir o check-in",
    text36: "O campo nome é obrigatório",
    text37: "O campo sobrenome é obrigatório",
    text38: "O campo gênero é obrigatório",
    text39: "O campo data de nascimento é obrigatório",
    text40: "O campo telefone é obrigatório",
    text41: "O campo data da hospedagem é obrigatório",
    text42: "O campo e-mail é obrigatório",
    text43: "O campo país é obrigatório",
    text44: "O campo tipo de documento é obrigatório",
    text45: "O campo número do documento é obrigatório",
    text46: "Você precisa aceitar os termos e condições.",
    text47: "Enviando os dados do check-in, aguarde...",
    text48: "Carregando...",
    text49: "concluiu o check-in com sucesso.",
    text50: "Clique aqui para ver todos os serviços disponíveis no hotel",
    text51: "Insira o nome",
    text52: "Insira o sobrenome",
    text53: "País",
    text54: "Erro",
    text55: "Insira o endereço de e-mail",

    // Corrections
    p1: "Data de check-in",
    p2: "Data de check-out",
    p3: "Data de emissão do documento",
    p4: "",
    p5: "",
    p6: "",
    p7: "",
    p8: "",
};
